<div class="col-md-6 col-lg-6 mt-1">
  <mat-form-field class="ml-2 w-100">
    <input matInput [matDatepicker]="dp" (focus)="dp.open();" [placeholder]="placeholder"
           readonly [(ngModel)]="value">
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker #dp
                    startView="multi-year"
                    (monthSelected)="setMonthAndYear($event, dp)"
                    panelClass="example-month-picker">
    </mat-datepicker>
  </mat-form-field>
</div>
